module.exports = __webpack_public_path__ + "img/ic_comment.4e35fac3.svg";